export enum SellerTypeListEnum {
    Alterdata = 0,
    Representacao = 1,
    Vendedor = 2,
}
